module.exports = __webpack_public_path__ + "img/taskPackage.30eeee01.svg";